export const EVENT_BEAM_SELECTION_CHANGED = "EVENT_BEAM_SELECTION_CHANGED";
export const EVENT_GUI_INPUT_MODE_CHANGED = "EVENT_GUI_INPUT_MODE_CHANGED_(GuiInputMode)";